import React from "react";
import {useTranslation} from "react-i18next";
import {closeModal, openModal} from "helpers/actions";
import {CreditsExplainerPage} from "pages/Front/Booking/Credits/CreditCalculator/components/CreditsExplainerPage";
import {useDispatch} from "useDispatch";
import {ModalSize} from "pages/Front/components/Popup";

const AttractionItem = (props: {title: string; credits: number; image_url: string}) => {
    return (
        <div className={"AttractionItem flex flex-row items-center gap-4 min-w-[200px]"}>
            <img src={props.image_url} alt="go-kart race" className="w-[40px] h-[40px] flex-none" />
            <div className={"flex flex-col gap-1 justify-center items-start"}>
                <span className={"text-black text-sm font-semibold"}>{props.title}</span>
                <span className={"text-black text-[10px] font-medium"}>1 Fahrt - {props.credits} Credits</span>
            </div>
        </div>
    );
};
const CreditsInfo = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const openCreditCalculatorModal = () => {
        dispatch(openModal(<CreditsExplainerPage onClose={() => dispatch(closeModal())} />, {modalSize: ModalSize.Scrollable}));
    };
    return (
        <div
            className={
                "CreditsInfo flex flex-col lg:grid lg:grid-cols-[44fr_56fr] xl:grid-cols-[46fr_54fr] items-center w-full bg-[#F5F5F566] px-2 lg:px-3 xl:px-4 py-4 lg:py-8 gap-4 lg:gap-4 mb-4 lg:mb-0 border-t border-b lg:border-0 border-black/5"
            }
            onClick={openCreditCalculatorModal}
        >
            <div
                className={
                    "flex flex-col sm:flex-row items-center justify-center gap-4 w-full lg:grid lg:grid-cols-[8fr_36fr] xl:grid-cols-[10fr_36fr] lg:gap-4"
                }
            >
                <div className={"sm:w-auto flex justify-center"}>
                    <img src="/img/credits/credits-percentage-icon.svg" alt="percentage icon" className="size-[56px] xl:size-[62px] flex-none" />
                </div>

                <div className={"font-semibold text-xs text-[#1E1E1E] lg:mx-auto text-center sm:text-left"}>
                    <p>{t("The larger the package, the lower the price per credit.")}</p>
                    <p>{t("Remaining credits are saved for your next visit.")}</p>
                    <p>{t("You decide what to ride in the park.")}</p>
                </div>
            </div>

            <div className={"flex flex-col md:flex-row items-center gap-4 w-full lg:grid lg:grid-cols-[48fr_8fr] xl:grid-cols-[42fr_12fr] lg:gap-4"}>
                <div className={"flex justify-center items-center lg:order-2"}>
                    <img src="/img/credits/credits-info-icon.svg" alt="info icon" className="size-[32px] flex-none" />
                </div>

                <div className={"flex flex-col xs:flex-row items-center xs:items-start xs:justify-evenly gap-4 w-full lg:order-1"}>
                    <AttractionItem credits={18} title={t("Go-Kart")} image_url={"/img/credits/credits-go-karting.svg"} />
                    {/*<AttractionItem credits={14} title={t("Zosh Super Drift")} image_url={"/img/credits/credits-zosh.svg"} />*/}
                    <AttractionItem credits={4} title={t("Crazy-Drift")} image_url={"/img/credits/credits-drift.svg"} />
                </div>
            </div>
        </div>
    );
};

export default CreditsInfo;
